import React from "react";
import "./Meals.css";
import MealsData from "./MealsData";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

export default function Meals(props) {
  const navigate = useNavigate();

  const openMealCalorieHandler = (id, label) => {
    navigate(`/mealCalorieSelector/${id}`, {
      state: { date: props.shamsiDate, mealLabel: label },
    });
  };

  return (
    <div className="mealsContainer centeredFlex">
      {MealsData.map((meal) => (
        <div key={meal.id} className="meal centeredFlex">
          <img src={meal.img} alt="meals icon" className="mealImg" />
          <span className="mealName">
            {meal.name.includes("میان وعده") ? "میان وعده" : meal.name}
          </span>
          <span className="mealCalories">
            {(props.mealsData && props.mealsData[meal.label])
              ? props.mealsData[meal.label]
              : 0.0}{" "}
            cal
          </span>
          <div
            onClick={() => openMealCalorieHandler(meal.id, meal.label)}
            className="mealBtn centeredFlex"
          >
            <AddIcon className="mealAddIcon" />
          </div>
        </div>
      ))}
    </div>
  );
}
